function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b48d4dc8-8068-4de8-81dc-ff71d2be8fbe",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "bc40f528-e79d-4610-92aa-9a295023d791",
    "data-name": "Wave-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a4d16e7b-23c9-41d8-bd6b-1970e5cbf18c",
    "data-name": "Rectangle",
    d: "M1366,48C715,48,651,0,0,0V48Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave10;